import type React from "react";
import styles from "./index.module.css";

// TypeScript interfaces for the data structure
export interface SuspectUser {
  userId: number;
  accesses: number;
}

export interface SuspectPlace {
  name: string;
  accesses: number;
}

type Props =
  | {
      selectedTarget: "users";
      data: SuspectUser[];
    }
  | {
      selectedTarget: "access-points";
      data: SuspectPlace[];
    };

// Main component
const SuspectBehaviorPageContent: React.FC<Props> = (props) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {props.selectedTarget === "users"
          ? "Suspect Users"
          : "Suspect Access Points"}
      </h2>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead className={styles.tableHead}>
            <tr>
              <th className={styles.tableHeader}>
                {props.selectedTarget === "users" ? "User ID" : "Access Point"}
              </th>
              <th className={styles.tableHeader}>Accesses</th>
            </tr>
          </thead>
          <tbody className={styles.tableBody}>
            {props.selectedTarget === "users"
              ? props.data.map((d, index) => (
                  <tr
                    key={d.userId}
                    className={`${styles.tableRow} ${
                      index % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd
                    }`}
                  >
                    <td
                      className={`${styles.tableCell} ${styles.tableCellUserId}`}
                    >
                      {d.userId}
                    </td>
                    <td className={styles.tableCell}>{d.accesses}</td>
                  </tr>
                ))
              : props.data.map((d, index) => (
                  <tr
                    key={d.name}
                    className={`${styles.tableRow} ${
                      index % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd
                    }`}
                  >
                    <td
                      className={`${styles.tableCell} ${styles.tableCellPlace}`}
                    >
                      {d.name}
                    </td>
                    <td className={styles.tableCell}>{d.accesses}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>

      {props.data.length === 0 && (
        <div className={styles.emptyState}>No data available</div>
      )}
    </div>
  );
};

export default SuspectBehaviorPageContent;
